import _classCallCheck from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { AsyncSubject } from 'rxjs';
import { CLUSTER } from './constants';
import { socketReconnect } from './actions';
export var TrafficControlWebSocketConnection = /*#__PURE__*/function () {
  function TrafficControlWebSocketConnection(store) {
    var _this = this;
    _classCallCheck(this, TrafficControlWebSocketConnection);
    this.store = store;
    this.lostConnection = false;
    this.subscribe = function (fun) {
      return _this.socketConnection.subscribe(fun);
    };
    this.socketConnection = this.open();
  }
  _createClass(TrafficControlWebSocketConnection, [{
    key: "open",
    value: function open() {
      var _this2 = this;
      var sub = new AsyncSubject();
      var socket = this.store.getState().socket;
      socket.onOpen(function () {
        if (_this2.lostConnection) {
          _this2.store.dispatch(socketReconnect(CLUSTER.CHAT));
        }
      });
      socket.onClose(function () {
        _this2.lostConnection = true;
      });
      sub.next(socket);
      sub.complete();
      return sub;
    }
  }]);
  return TrafficControlWebSocketConnection;
}();